import React from "react";
import PropTypes from "prop-types";
import { Container, Row, Col } from "reactstrap";
import Skeleton from "react-loading-skeleton";

import { MyDraggable as Draggable } from "../components/Core";
import HoverBar from "../components/HoverBar";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

import { generateStyle, l, setOverLay } from "../functions";
import Icon from "../components/Icons";

import { connect } from "react-redux";
import store from "../core/redux/store";
import isEqual from "lodash/isEqual";

const mapStateToProps = (state) => {
  return {
    currentLang: state.rootReducer.currentLang || 1,
    settings: state.rootReducer.appearanceSettings || {},
    currentDevice: state.rootReducer.currentDevice || null,
  };
};

class Slider extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      settings: {
        nav: true,
        dots: false,
        mouseDrag: false,
        loop: false,
        items: 1,
        navText: [
          '<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 6.2 11"><path fill="#A4A8C0" d="M6,9.8c0.3,0.3,0.3,0.7,0,1s-0.7,0.3-1,0L0.2,6c-0.3-0.3-0.3-0.7,0-1L5,0.2c0.3-0.3,0.7-0.3,1,0s0.3,0.7,0,1 L1.7,5.5L6,9.8z"/></svg>',
          '<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 6.2 11"><path fill="#A4A8C0" d="M6,9.8c0.3,0.3,0.3,0.7,0,1s-0.7,0.3-1,0L0.2,6c-0.3-0.3-0.3-0.7,0-1L5,0.2c0.3-0.3,0.7-0.3,1,0s0.3,0.7,0,1 L1.7,5.5L6,9.8z"/></svg>',
        ],
      },
    };

    this.sliderKey = 1;
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { payload } = nextProps;
    const currentPayload = this.props?.payload;
    const currentSlides = currentPayload?.datas?.slider;
    const nextSlides = payload?.datas?.slider;
    if (currentSlides?.length !== nextSlides?.length) {
      return true;
    }
    if (
      !isEqual(currentPayload, payload) ||
      !isEqual(this.state, nextState) ||
      !isEqual(nextProps.settings, this.props.settings)
    ) {
      return true;
    }
    return false;
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.id &&
      nextProps.options &&
      nextProps.options.carousel &&
      nextProps.payload &&
      nextProps.payload.datas
    ) {
      const datasSliderSettigns =
        nextProps.payload.datas?.sliderSettings || null;
      const settingsSliderSettigns =
        nextProps.payload["settings-" + nextProps.currentDevice]
          ?.sliderSettings ||
        nextProps.payload.settings?.sliderSettings ||
        null;
      const sliderSettings = {
        ...datasSliderSettigns,
        ...settingsSliderSettigns,
      };

      if (sliderSettings) {
        const { item_count_desktop, item_count_tab, item_count_mobile } =
          sliderSettings;
        const { item_spacing_desktop, item_spacing_tab, item_spacing_mobile } =
          sliderSettings;

        this.setState(
          {
            ...this.state,
            settings: {
              ...this.state.settings,
              items: item_count_desktop || 1,
              responsive: {
                0: {
                  items:
                    item_count_mobile ||
                    item_count_tab ||
                    item_count_desktop ||
                    1,
                  margin:
                    item_spacing_mobile ||
                    item_spacing_tab ||
                    item_spacing_desktop ||
                    0,
                },
                700: {
                  items: item_count_tab || item_count_desktop || 1,
                  margin: item_spacing_tab || item_spacing_desktop || 0,
                },
                1300: {
                  items: item_count_desktop || 1,
                  margin: item_spacing_desktop || 0,
                },
              },
            },
          },
          () => {
            this.sliderKey = this.sliderKey + 1;
          }
        );
      }
    }
  }

  _renderSkeleton = (sliderSettings) => {
    const element = document.getElementById("carousel");
    const noOfElement = Math.round(element?.offsetWidth / 400) || 1;
    const elements = Array(noOfElement)
      .fill()
      .map(() => {
        return (
          <Skeleton
            height={sliderSettings.height ? sliderSettings.height : 400}
            width={280}
            style={{ marginRight: 10 }}
          />
        );
      });
    return elements;
  };

  _emptySlide = (options, sliderSettings = {}, preview, payload) => {
    const designLayout = sliderSettings.testimonialDesignLayout || "default";

    return (
      (!preview && options && options.testimonial && (
        <Container fluid={payload.fullContainer} className="testimonial">
          {(!designLayout || (designLayout && designLayout === "default")) && (
            <div className="layout">
              <Row>
                <Col md={12}>
                  <div className="empty">
                    <h1>Please add a Testimonail</h1>
                  </div>
                  <div className="img" style={{ marginBottom: "15px" }}>
                    <Skeleton circle={true} height={100} width={100} />
                  </div>
                  <div className="content">
                    <h3>
                      <Skeleton width={150} />
                    </h3>
                    <p className="subtitle">
                      <Skeleton width={100} />
                    </p>
                    <p className="text" style={{ lineHeight: "26px" }}>
                      <Skeleton count={3} height={12} width={300} />
                    </p>
                  </div>
                </Col>
              </Row>
            </div>
          )}
        </Container>
      )) ||
      (!preview && options && options.carousel && (
        <p
          className="inline-carousel-skeleton"
          style={{
            height: sliderSettings.height ? sliderSettings.height : 400,
            margin: 10,
          }}
          id="carousel"
        >
          <div className="empty">
            <h1>Please add a carousel slide</h1>
          </div>
          {this._renderSkeleton(sliderSettings)}

          {/* {payload.fullContainer && (
            <>
              <span style={{ marginRight: 10 }} />
              <Skeleton
                height={sliderSettings.height ? sliderSettings.height : 400}
                width={280}
              />
            </>
          )} */}
        </p>
      )) ||
      (!preview && (
        <div
          style={{
            height: sliderSettings.height ? sliderSettings.height : 400,
            margin: 10,
          }}
        >
          <div className="empty">
            <h1>Please add a slide</h1>
          </div>
          <Skeleton
            height={sliderSettings.height ? sliderSettings.height : 400}
          />
        </div>
      ))
    );
  };

  _slideItem = (options, slide, sliderSettings, datas) => {
    const settings =
      store.getState().rootReducer?.appearanceSettings ||
      this.props.settings ||
      {};
    const itemCss = {
      height: "auto",
      // height: sliderSettings.height
      //   ? sliderSettings.height
      //   : !options.testimonial
      //   ? 400
      //   : "auto",
    };

    const isTestimonial = options && options.testimonial;

    const { titleTag: MyTitle = isTestimonial ? "h2" : "h3" } =
      datas || this.props.payload?.datas || {};

    if (!(options && (options.testimonial || options.carousel))) {
      if (slide["image_" + this.props.currentLang])
        itemCss.backgroundImage =
          "url(" + slide["image_" + this.props.currentLang] + ")";
      else if (slide["image"])
        itemCss.backgroundImage = "url(" + slide["image"] + ")";
    }

    const titleCss = {
      color:
        sliderSettings.titleColor ||
        settings["H2"]?.color ||
        settings["heading_color"]?.color ||
        null,
      textAlign: sliderSettings.titleTextAlign || null,
      fontFamily:
        sliderSettings.titleFontFamily ||
        settings["heading_font"]?.fontFamily ||
        null,
      fontWeight: sliderSettings.titleFontWeight || null,
      fontSize:
        sliderSettings.titleFontSize ||
        settings[MyTitle?.toUpperCase()]?.size ||
        null,
      letterSpacing: sliderSettings.titleLetterSpacing || null,

      marginTop: (sliderSettings.title_marginTop || 0) + "px",
      marginLeft: (sliderSettings.title_marginLeft || 0) + "px",
      paddingLeft: (sliderSettings.title_paddingLeft || 0) + "px",
      paddingTop: (sliderSettings.title_paddingTop || 0) + "px",
      paddingBottom: (sliderSettings.title_paddingBottom || 0) + "px",
      paddingRight: (sliderSettings.title_paddingRight || 0) + "px",
      marginRight: (sliderSettings.title_marginRight || 0) + "px",
      marginBottom: (sliderSettings.title_marginBottom || 0) + "px",
    };

    const subtitleCss = {
      color:
        sliderSettings.subtitleColor ||
        settings["H3"]?.color ||
        settings["heading_color"]?.color ||
        null,
      textAlign: sliderSettings.subtitleTextAlign || null,
      fontFamily:
        sliderSettings.subtitleFontFamily ||
        settings["heading_font"]?.fontFamily ||
        null,
      fontWeight: sliderSettings.subtitleFontWeight || null,
      fontSize: sliderSettings.subtitleFontSize || settings["H4"]?.size || null,
      letterSpacing: sliderSettings.subtitleLetterSpacing || null,

      marginTop: (sliderSettings.subtitle_marginTop || 0) + "px",
      marginLeft: (sliderSettings.subtitle_marginLeft || 0) + "px",
      paddingLeft: (sliderSettings.subtitle_paddingLeft || 0) + "px",
      paddingTop: (sliderSettings.subtitle_paddingTop || 0) + "px",
      paddingBottom: (sliderSettings.subtitle_paddingBottom || 0) + "px",
      paddingRight: (sliderSettings.subtitle_paddingRight || 0) + "px",
      marginRight: (sliderSettings.subtitle_marginRight || 0) + "px",
      marginBottom: (sliderSettings.subtitle_marginBottom || 0) + "px",
    };

    const testimonialCss = {
      color:
        sliderSettings.testimonialColor ||
        settings["body_color"]?.color ||
        null,
      textAlign: sliderSettings.testimonialTextAlign || null,
      fontFamily:
        sliderSettings.testimonialFontFamily ||
        settings["body_font"]?.fontFamily ||
        null,
      fontWeight: sliderSettings.testimonialFontWeight || null,
      fontSize: sliderSettings.testimonialFontSize || null,
      letterSpacing: sliderSettings.testimonialLetterSpacing || null,

      marginTop: (sliderSettings.testimonial_marginTop || 0) + "px",
      marginLeft: (sliderSettings.testimonial_marginLeft || 0) + "px",
      paddingLeft: (sliderSettings.testimonial_paddingLeft || 0) + "px",
      paddingTop: (sliderSettings.testimonial_paddingTop || 0) + "px",
      paddingBottom: (sliderSettings.testimonial_paddingBottom || 0) + "px",
      paddingRight: (sliderSettings.testimonial_paddingRight || 0) + "px",
      marginRight: (sliderSettings.testimonial_marginRight || 0) + "px",
      marginBottom: (sliderSettings.testimonial_marginBottom || 0) + "px",
    };

    const linkCss = {
      color: sliderSettings.linkColor || settings["links_color"]?.color || null,
      backgroundColor: sliderSettings.linkBgColor || null,
      fontFamily:
        sliderSettings?.linkFontFamily ||
        settings["body_font"]?.fontFamily ||
        null,
      fontWeight: sliderSettings?.linkFontWeight || null,
      fontSize: sliderSettings?.linkFontSize || null,
      letterSpacing: sliderSettings?.linkLetterSpacing || null,

      marginTop: (sliderSettings.link_marginTop || 0) + "px",
      marginLeft: (sliderSettings.link_marginLeft || 0) + "px",
      paddingLeft: (sliderSettings.link_paddingLeft || 0) + "px",
      paddingTop: (sliderSettings.link_paddingTop || 0) + "px",
      paddingBottom: (sliderSettings.link_paddingBottom || 0) + "px",
      paddingRight: (sliderSettings.link_paddingRight || 0) + "px",
      marginRight: (sliderSettings.link_marginRight || 0) + "px",
      marginBottom: (sliderSettings.link_marginBottom || 0) + "px",

      borderRadius:
        ((sliderSettings.link_borderRadius &&
          sliderSettings.link_borderRadius["lt"]) ||
          0) +
        "px " +
        ((sliderSettings.link_borderRadius &&
          sliderSettings.link_borderRadius["rt"]) ||
          0) +
        "px " +
        ((sliderSettings.link_borderRadius &&
          sliderSettings.link_borderRadius["rb"]) ||
          0) +
        "px " +
        ((sliderSettings.link_borderRadius &&
          sliderSettings.link_borderRadius["lb"]) ||
          0) +
        "px",
    };

    const className = options && options.testimonial ? "testimonial" : "slide";

    return (
      <div className={className}>
        {(isTestimonial && (
          <div className="slider-block">
            <div className="testimonial">
              <div className="layout">
                {options &&
                  (options.testimonial || options.carousel) &&
                  slide["image_" + this.props.currentLang] && (
                    <img
                      src={slide["image_" + this.props.currentLang]}
                      alt="slide"
                    />
                  )}
                {options &&
                  (options.testimonial || options.carousel) &&
                  slide["image"] && <img src={slide["image"]} alt="slide" />}
                <div className="content">
                  <div>
                    {slide["title_" + this.props.currentLang] && (
                      <MyTitle style={titleCss}>
                        {slide["title_" + this.props.currentLang]}
                      </MyTitle>
                    )}
                    {slide["subtitle_" + this.props.currentLang] && (
                      <h3 className="subtitle" style={subtitleCss}>
                        {slide["subtitle_" + this.props.currentLang]}
                      </h3>
                    )}
                    {slide["text_" + this.props.currentLang] && (
                      <p className="text" style={testimonialCss}>
                        {slide["text_" + this.props.currentLang]}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )) || (
          <div style={itemCss}>
            <img src={slide["image_" + this.props.currentLang]} />

            {
              <div className="content">
                <div>
                  {slide["title_" + this.props.currentLang] && (
                    <MyTitle style={titleCss}>
                      {slide["title_" + this.props.currentLang]}
                    </MyTitle>
                  )}
                  {slide["subtitle_" + this.props.currentLang] && (
                    <h4 className="subtitle" style={subtitleCss}>
                      {slide["subtitle_" + this.props.currentLang]}
                    </h4>
                  )}
                  {slide.hasUrl &&
                    slide.url !== "" &&
                    slide["linklabel_" + this.props.currentLang] && (
                      <div style={{ textAlign: sliderSettings.linkTextAlign }}>
                        <span className="link" style={linkCss}>
                          {sliderSettings.useIcon &&
                            sliderSettings.iconPosition !== "right" &&
                            sliderSettings.iconClass &&
                            !Array.isArray(sliderSettings.iconClass) && (
                              <span className="left">
                                <FontAwesomeIcon
                                  icon={[
                                    "fas",
                                    sliderSettings.iconClass.replace("fa-", ""),
                                  ]}
                                />
                              </span>
                            )}
                          {sliderSettings.useIcon &&
                            sliderSettings.iconPosition !== "right" &&
                            sliderSettings.iconClass &&
                            Array.isArray(sliderSettings.iconClass) && (
                              <span className="left">
                                <FontAwesomeIcon
                                  icon={[
                                    sliderSettings.iconClass[0],
                                    sliderSettings.iconClass[1],
                                  ]}
                                />
                              </span>
                            )}

                          {slide["linklabel_" + this.props.currentLang]}

                          {sliderSettings.useIcon &&
                            sliderSettings.iconPosition === "right" &&
                            sliderSettings.iconClass &&
                            !Array.isArray(sliderSettings.iconClass) && (
                              <span className="right">
                                <FontAwesomeIcon
                                  icon={[
                                    "fas",
                                    sliderSettings.iconClass.replace("fa-", ""),
                                  ]}
                                />
                              </span>
                            )}
                          {sliderSettings.useIcon &&
                            sliderSettings.iconPosition === "right" &&
                            sliderSettings.iconClass &&
                            Array.isArray(sliderSettings.iconClass) && (
                              <span className="right">
                                <FontAwesomeIcon
                                  icon={[
                                    sliderSettings.iconClass[0],
                                    sliderSettings.iconClass[1],
                                  ]}
                                />
                              </span>
                            )}
                        </span>
                      </div>
                    )}
                </div>
              </div>
            }
          </div>
        )}
      </div>
    );
  };

  _listItems = (payload, options, preview) => {
    const items = payload && payload.datas && payload.datas.slider;
    const datas = payload && payload.datas;
    const datasSliderSettigns =
      payload && (payload.datas?.sliderSettings || null);
    const settingsSliderSettigns =
      payload &&
      (payload["settings-" + this.props.currentDevice]?.sliderSettings ||
        payload.settings?.sliderSettings ||
        null);
    const sliderSettings = {
      ...datasSliderSettigns,
      ...settingsSliderSettigns,
    };

    const cssSettings = generateStyle(payload, "container");
    const cssAlignment = generateStyle(payload, "alignment");

    let sliderClass;

    if (options) {
      if (options && options.testimonial) sliderClass = "testimonial";
      else if (options && options.carousel) sliderClass = "carousel";
      else sliderClass = "slide";
    } else sliderClass = "slide";

    const sliderKey = Math.round(Math.random() * 10000);
    return (
      <Container
        fluid={payload.fullContainer}
        style={{ ...cssSettings, overflow: "hidden" }}
        className="slideTestimonialsBlock"
      >
        {setOverLay(payload)}
        <Row>
          <Col xs={12} className="fullcol">
            <div
              className={`slider-block ${sliderClass}-container`}
              style={cssAlignment}
            >
              {(items && items.length > 0 && (
                <div>
                  {(preview && (
                    <div style={{ position: "relative" }}>
                      {(items[0].data &&
                        this._slideItem(
                          options,
                          items[0].data,
                          sliderSettings,
                          datas
                        )) ||
                        this._emptySlide(
                          options,
                          sliderSettings,
                          preview,
                          payload
                        )}
                    </div>
                  )) || (
                    <OwlCarousel
                      key={sliderKey}
                      {...this.state.settings}
                      style={{ width: "100%" }}
                    >
                      {items.map((item, index) => {
                        const slide = item.data;

                        return (
                          <div key={index} style={{ position: "relative" }}>
                            {(slide &&
                              this._slideItem(
                                options,
                                slide,
                                sliderSettings
                              )) ||
                              this._emptySlide(
                                options,
                                sliderSettings,
                                preview,
                                payload
                              )}
                          </div>
                        );
                      })}
                    </OwlCarousel>
                  )}
                </div>
              )) ||
                this._emptySlide(options, sliderSettings, preview, payload)}
            </div>
          </Col>
        </Row>
      </Container>
    );
  };

  render() {
    let {
      dropzoneID,
      parentID,
      showBasicContent,
      showPreview,
      id,
      dropzoneProps,
      payload,
      options,
      ...rest
    } = this.props;

    if (payload === null) payload = this.props.options.payload;

    if (showBasicContent) {
      return (
        <Draggable {...this.props} side={true}>
          <span className="dragger">
            {(Array.isArray(rest.icon) && (
              <FontAwesomeIcon icon={rest.icon} />
            )) || <Icon icon={rest.icon} />}
            <span>{l(rest.name)}</span>
          </span>
        </Draggable>
      );
    }

    if (showPreview) {
      return this._listItems(payload, options, true);
    }

    return (
      <Draggable {...this.props} minify={true}>
        <HoverBar
          datas={this.props}
          style={payload}
          parent={parentID}
          element={{ id, dropzoneID, parentID, payload }}
        />
        {this._listItems(payload, options, false)}
      </Draggable>
    );
  }
}

Slider.propTypes = {
  id: PropTypes.string.isRequired,
  showBasicContent: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(Slider);
